import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  transform(value: any, format: string = 'MM/DD/YYYY'): string {
    const date = moment(value);
    if (!date.isValid()) return ''; 
    return date.format(format);
  }
}